<template>
    <ac-modal :title="'Terminate Affiliation'" ref="modal" @ac-modal-closed="cancelPromise">
        <template>
            <div class="row">
                <div class="col-md-10">
                    <div class="alert alert-warning">
                        By terminating this affiliation, this provider will no longer be able to provide services
                        on behalf of your network. If the provider is offering any of your plans to employees not
                        associated with your network, those plans will be terminated, as well.
                        Patient(s) will be notified of this change.
                        <strong>This action cannot be undone.</strong>
                    </div>
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button type="button" class="btn btn-red btn-sm" :action="close">
                Cancel
            </ac-button>
            <ac-button type="button" class="btn btn-yellow btn-sm" :action="terminateAffiliation">
                Terminate Affiliation
            </ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "TerminateAffiliationModal",
        data() {
            return {
                affiliationId: 0,
                resolveRef: null
            };
        },
        methods: {
            async showModal(affiliationId) {
                this.affiliationId = affiliationId;
                this.$refs.modal.open();
                return new Promise((resolve, reject) => {
                    this.resolveRef = resolve;
                });
            },
            cancelPromise() {
                this.resolveRef(false);
            },
            close() {
                this.resolveRef(false);
                this.$refs.modal.close();
            },
            async terminateAffiliation() {
                let result = await api.post('Affiliation', 'TerminateAffiliation', {affiliationId: this.affiliationId});
                if (result) {
                    this.resolveRef(true);
                    this.$refs.modal.close();
                }
            }
        }
    }
</script>

<style scoped>

</style>